<template>
    <div class="sidebar__menu">
        <div class="sidebar-item">
            <div class="sidebar-item__img">
                <img :src="require('@/assets/img/electronic.svg')" alt="Электроника">
            </div>
            <span>Электроника</span>
        </div>
        <div class="sidebar-item">
            <div class="sidebar-item__img">
                <img :src="require('@/assets/img/eco.svg')" alt="Экотовары">
            </div>
            <span>Экотовары</span>
        </div>
        <div class="sidebar-item">
            <div class="sidebar-item__img">
                <img :src="require('@/assets/img/beauty.svg')" alt="Красота и здоровье">
            </div>
            <span>Красота и здоровье</span>
        </div>
        <div class="sidebar-item">
            <div class="sidebar-item__img">
                <img :src="require('@/assets/img/homegoods.svg')" alt="Товары для дома">
            </div>
            <span>Товары для дома</span>
        </div>
        <div class="sidebar-item">
            <div class="sidebar-item__img">
                <img :src="require('@/assets/img/garden.svg')" alt="Сад и огород">
            </div>
            <span>Сад и огород</span>
        </div>
        <div class="sidebar-item">
            <div class="sidebar-item__img">
                <img :src="require('@/assets/img/watch.svg')" alt="">
            </div>
            <span>Часы</span>
        </div>
        <div class="sidebar-item">
            <div class="sidebar-item__img">
                <img :src="require('@/assets/img/jeweleries.svg')" alt="Украшения и бижутерия">
            </div>
            <span>Украшения и бижутерия</span>
        </div>
        <div class="sidebar-item sidebar-item__all">
            <span>Все категории</span>
            <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>
        </div>
    </div>
</template>

<script>
    import { ChevronRightIcon } from 'vue-feather-icons';

    export default {
        name: "CategoryNav",
        components: {
            ChevronRightIcon
        },
    };
</script>

<style scoped lang="scss">
    @import "./src/styles/menu.scss";

    .sidebar__menu {
        margin-top: 0;
    }
</style>
